<template><div><h3>Msg_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fmsg"/>
<p><a href="https://vux.li/demos/v2/#/component/msg" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/msg</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/msg" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">msg</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Yeah! You make it')"</span> <span class="hljs-attr">:description</span>=<span class="hljs-string">"$t('Msg description')"</span> <span class="hljs-attr">:buttons</span>=<span class="hljs-string">"buttons"</span> <span class="hljs-attr">:icon</span>=<span class="hljs-string">"icon"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">msg</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>



<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { Msg, Divider, XButton } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">components</span>: {
    Msg,
    Divider,
    XButton
  },
  <span class="hljs-attr">methods</span>: {
    changeIcon () {
      <span class="hljs-keyword">if</span> (!<span class="hljs-keyword">this</span>.icon || <span class="hljs-keyword">this</span>.icon === <span class="hljs-string">'success'</span>) {
        <span class="hljs-keyword">this</span>.icon = <span class="hljs-string">'warn'</span>
        <span class="hljs-keyword">return</span>
      }
      <span class="hljs-keyword">if</span> (<span class="hljs-keyword">this</span>.icon === <span class="hljs-string">'warn'</span>) {
        <span class="hljs-keyword">this</span>.icon = <span class="hljs-string">'info'</span>
        <span class="hljs-keyword">return</span>
      }
      <span class="hljs-keyword">if</span> (<span class="hljs-keyword">this</span>.icon === <span class="hljs-string">'info'</span>) {
        <span class="hljs-keyword">this</span>.icon = <span class="hljs-string">'waiting'</span>
        <span class="hljs-keyword">return</span>
      }
      <span class="hljs-keyword">if</span> (<span class="hljs-keyword">this</span>.icon === <span class="hljs-string">'waiting'</span>) {
        <span class="hljs-keyword">this</span>.icon = <span class="hljs-string">'success'</span>
      }
    }
  },
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">description</span>: <span class="hljs-string">'msg description'</span>,
      <span class="hljs-attr">icon</span>: <span class="hljs-string">''</span>,
      <span class="hljs-attr">buttons</span>: [{
        <span class="hljs-attr">type</span>: <span class="hljs-string">'primary'</span>,
        <span class="hljs-attr">text</span>: <span class="hljs-string">'Primary button'</span>,
        <span class="hljs-attr">onClick</span>: <span class="hljs-keyword">this</span>.changeIcon.bind(<span class="hljs-keyword">this</span>)
      }, {
        <span class="hljs-attr">type</span>: <span class="hljs-string">'default'</span>,
        <span class="hljs-attr">text</span>: <span class="hljs-string">'Secondary button'</span>,
        <span class="hljs-attr">link</span>: <span class="hljs-string">'/demo'</span>
      }]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// msg-391.vue?291a9e64